import {useGracePeriodNotification} from '@dms/shared';

import {Dashboard} from './components/Dashboard';

export function Homepage() {
  useGracePeriodNotification();

  return <Dashboard />;
}
